import { render, staticRenderFns } from "./MediaArticle.vue?vue&type=template&id=370447da&scoped=true&"
import script from "./MediaArticle.vue?vue&type=script&lang=js&"
export * from "./MediaArticle.vue?vue&type=script&lang=js&"
import style0 from "./MediaArticle.vue?vue&type=style&index=0&id=370447da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370447da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
